/**
 * Volume Discount API - Cart line item savings
 * Fetches volume discount per variant and shows "Save $X" or "$Y each" for qualifying quantities.
 */
(function () {
  const VOLUME_DISCOUNT_API_BASE = 'https://ctd-shipping.flogi.app';

  function fetchVolumeDiscount(variantGid, signal) {
    if (!variantGid) return Promise.resolve({ hasDiscount: false, discounts: [] });
    const url = `${VOLUME_DISCOUNT_API_BASE}/api/volume-discounts-info?variantId=${encodeURIComponent(variantGid)}`;
    return fetch(url, { signal, headers: { Accept: 'application/json' } })
      .then((res) => (res.ok ? res.json() : { hasDiscount: false, discounts: [] }))
      .catch((err) => {
        if (err.name !== 'AbortError') console.warn('Volume discount cart API error:', err);
        return { hasDiscount: false, discounts: [] };
      });
  }

  function calculateDiscountedPrice(originalPrice, quantity, discountRules) {
    if (!discountRules || discountRules.length === 0) return originalPrice;
    const sortedRules = [...discountRules].sort((a, b) => b.minQuantity - a.minQuantity);
    const rule = sortedRules.find((r) => quantity >= r.minQuantity);
    if (!rule) return originalPrice;
    if (rule.discountType === 'fixed_price') return parseFloat(rule.discountValue);
    if (rule.discountType === 'percentage') {
      return originalPrice * (1 - parseFloat(rule.discountValue) / 100);
    }
    return originalPrice;
  }

  function formatPrice(value, currency) {
    const num = typeof value === 'number' ? value : parseFloat(value);
    if (Number.isNaN(num)) return '$0.00';
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency || 'USD',
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(num);
    } catch {
      return `$${num.toFixed(2)}`;
    }
  }

  function updateCartSavings() {
    const elements = document.querySelectorAll('.volume-discount-cart-savings');
    elements.forEach((el) => {
      const variantGid = el.dataset.variantGid;
      const quantity = parseInt(el.dataset.quantity, 10);
      const originalPrice = parseFloat(el.dataset.originalPrice);
      const currency = el.dataset.currency || 'USD';
      if (!variantGid || Number.isNaN(quantity) || Number.isNaN(originalPrice)) return;

      const controller = new AbortController();
      el._volumeDiscountAbort = controller;

      fetchVolumeDiscount(variantGid, controller.signal).then((data) => {
        if (el._volumeDiscountAbort !== controller) return;
        el.textContent = '';
        if (!data.hasDiscount || !data.discounts || data.discounts.length === 0) return;

        const discountedPrice = calculateDiscountedPrice(originalPrice, quantity, data.discounts);
        const savings = originalPrice * quantity - discountedPrice * quantity;
        if (savings > 0) {
          el.textContent = `Save ${formatPrice(savings, currency)}`;
          el.classList.add('volume-discount-cart-savings--visible');
        } else {
          el.textContent = `${formatPrice(discountedPrice, currency)} each`;
          el.classList.add('volume-discount-cart-savings--visible');
        }
      });
    });
  }

  function init() {
    updateCartSavings();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      setTimeout(updateCartSavings, 100);
    });
  }
})();
